<template>
  <ValidationObserver>
    <div id="personal-infos" slot-scope="{ invalid, validated }">
      <v-form>
        <v-card>
          <v-card-title primary-title class="amber lighten-1">
            <v-layout align-baseline justify-space-between>
              <h3 class="headline pb-2 blue--text text--darken-4"><v-icon color="blue darken-4">face</v-icon> Informations personnelles</h3>
              <SectionsLayout
                :cv_id='cv_id'
                section='persinfos'
              >
              </SectionsLayout>
            </v-layout>
          </v-card-title>

          <v-card-text>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12 sm12 md10>


                  <v-layout row wrap>

                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <ValidationProvider name="prénom" rules="max:32">
                        <v-text-field
                          slot-scope="{
                                      errors,
                                      valid
                                      }"
                          :error-messages="errors"
                          :success="valid"
                          label="Prénom:"
                          v-model="modelObject.firstname"
                          v-on:blur="updateModelObject(modelObject.curriculum, modelObject)"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-flex>

                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <ValidationProvider name="nom" rules="max:32">
                        <v-text-field
                          slot-scope="{
                                      errors,
                                      valid
                                      }"
                          :error-messages="errors"
                          :success="valid"
                          label="Nom:"
                          v-model="modelObject.lastname"
                          v-on:blur="updateModelObject(modelObject.curriculum, modelObject)"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-flex>


                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        full-width
                        max-width="290"
                      >
                        <v-text-field
                          slot="activator"
                          :value="printTheDate(modelObject.birthday)"
                          label="Date de naissance:"
                          prepend-icon="event"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          :value="computedDateFormatted"
                          locale='fr-FR'
                          @input="saveTheDate(modelObject.curriculum, modelObject, $event), menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <ValidationProvider name="téléphone" rules="max:24">
                        <v-text-field
                          slot-scope="{
                                      errors,
                                      valid
                                      }"
                          :error-messages="errors"
                          :success="valid"
                          label="Téléphone:"
                          v-model="modelObject.telephone"
                          v-on:blur="updateModelObject(modelObject.curriculum, modelObject)"
                        >
                        </v-text-field>
                      </ValidationProvider>

                    </v-flex>


                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <ValidationProvider name="numero et rue" rules="max:64">
                        <v-text-field
                          slot-scope="{
                                      errors,
                                      valid
                                      }"
                          :error-messages="errors"
                          :success="valid"
                          label="Numéro et rue:"
                          v-model="modelObject.address_street"
                          v-on:blur="updateModelObject(modelObject.curriculum, modelObject)"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-flex>

                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <ValidationProvider name="code postal" rules="max:10">
                        <v-text-field
                          slot-scope="{
                                      errors,
                                      valid
                                      }"
                          :error-messages="errors"
                          :success="valid"
                          label="Code postal:"
                          v-model="modelObject.address_postal_code"
                          v-on:blur="updateModelObject(modelObject.curriculum, modelObject)"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-flex>


                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <ValidationProvider name="ville" rules="max:32">
                        <v-text-field
                          slot-scope="{
                                      errors,
                                      valid
                                      }"
                          :error-messages="errors"
                          :success="valid"
                          label="Ville:"
                          v-model="modelObject.address_city"
                          v-on:blur="updateModelObject(modelObject.curriculum, modelObject)"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-flex>

                    <v-flex xs12 sm6 md6 lg6 xl6 pb-0>
                      <ValidationProvider name="pays" rules="max:32">
                        <v-text-field
                          slot-scope="{
                                      errors,
                                      valid
                                      }"
                          :error-messages="errors"
                          :success="valid"
                          label="Pays:"
                          v-model="modelObject.address_country"
                          v-on:blur="updateModelObject(modelObject.curriculum, modelObject)"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-flex>


                  </v-layout>


                </v-flex>

                <v-flex xs12 sm12 md2>
                  <v-card elevation=0>
                    <v-card-title primary-title class="pt-0">
                      <div>
                        <h6 class="subheading mb-0">Votre Photo:</h6>

                      </div>
                    </v-card-title>

                    <v-img contain v-if="modelObject.picture_file" v-bind:src="modelObject.picture_file_url" alt="Votre photo" height="160"></v-img>
                    <v-img contain v-else :src="require('./default-avatar.png')" alt="Votre photo" height="160"></v-img>

                    <v-card-actions class="justify-center">
                      <div class="px-2">
                        <v-btn  flat icon color="info" @click="$refs.the_file.click()">
                          <v-icon large >cloud_upload</v-icon>
                        </v-btn>
                        <input
                          type="file"
                          style="display: none"
                          ref="the_file"
                          accept="image/*"
                          @change="pictureFileHandler(modelObject.curriculum, modelObject, $event.target.files)"
                        >
                      </div>
                      <div class="px-2">
                        <v-btn  flat icon color="orange" @click="pictureDeleteHandler(modelObject.curriculum, modelObject)" >
                          <v-icon large dark >clear</v-icon>
                        </v-btn>
                      </div>
                    </v-card-actions>

                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>

        </v-card>
      </v-form>
    </div>
  </ValidationObserver>
</template>

<script>
 import {
   ValidationObserver,
   ValidationProvider,
   withValidation
 } from "vee-validate";
 import { mixin_one_ajax } from './mixin_one_ajax.js';
 // import Spinner from 'vue-simple-spinner';
 // import Datepicker from 'vuejs-datepicker';
 import {fr} from 'vuejs-datepicker/dist/locale'
 import session from '../api/session';
 import SectionsLayout from '../components/SectionsLayout';
 import moment from 'moment';

 import { mapActions, mapGetters, mapState } from 'vuex';

 export default {

   mixins: [mixin_one_ajax],
   // components: {
   //     Datepicker,
   // },
   props: ['cv_id'],
   components: {
     SectionsLayout,
     ValidationProvider,
     ValidationObserver
   },
   data: function() {
     return {
       fr: fr, // pour le datepicker
       api_url: '/api/' + this.cv_id + '/infoperso/' + this.cv_id + '/',
       api_url_post: '/api/' + this.cv_id + '/infoperso/',
       modelObject: [],
       isLoading: false,
       currentModelObject: {},
       message: null,
       newModelObject: function() {
         return {
           // inutile de spécifier les autres champs ici!
           'curriculum': this.cv_id,
         }
       },
       menu1: false,
     }
   },


   // NOTE: A voir plus tard
   // computed: {
   //   defaultAvatar () {
   //     // return "/PROJECTS/CODE/cv_project/cv_frontend/static/cv_frontend/js/dist"+Icon;
   //     return require('./idavatar.png')
   //   }
   // },


   /*
      Due à la particularité du téléversement de fichier, la méthode 'updateModelObject' doit
      être surdéfinie par rapport au mixin.
      En effet, le téléversement de fichiers ne peut se faire via la soumission d'un objet json (Content-Type 'application/json'.)
      L'erreur :
      <!-- The submitted data was not a file. Check the encoding type on the form. -->
      sera reportée par DRF.

      Il est nécessaire d'inclure le fichier dans un objet de type 'formData'.
      le Content-type  est auto-déterminé par Axios et sera 'multipart/form-data' (voir Headers d'envoi)
      formData nécessite que tout les champs soient renseignés. Mais comme on 'put' un update lorsque chaque
      champs est mis à jour, on peut se contenter de ne pousser que l'objet fichier et curriculum (nécessaire) lorque ce champ
      précis est MAJ :
      méthode vuejs dédiée : 'pictureFileHandler'

      Cependant, une fois le fichier téléverser, le champ 'picture_file' n'est plus un objet fichier, mais un string qui
      pointe sur l'url de stockage de ce fichier.
      Afin d'éviter l'erreur de validation de DRF qui s'attend à un objet image,
      il ne faut pas inclure ce champs dans le 'put' json lors de l'update déclanchée par la MAJ d'un autre champ.

      Par conséquent, dans 'updateModelObject' on réalise un premier test afin de vérifier le type du champ 'picture_file'.
      SI c'est un fichier, ALORS on put via formData.
      SINON on put via un objet json temporaire :
      SI le 'picture_file' n'est pas null (une chaine URL),
      on put via un objet json temporaire dans lequel le champ 'picture_file' est omis afin d'éviter l'erreur de validation de DRF.
      SINON, le champ est null et le champ 'picture_file' est positionné à null : ainsi la référence au fichier image est supprimée.
    */

   computed: {
     computedDateFormatted () {
       return this.printTheDate(this.date)
     }
   },
   methods: {
     ...mapActions('loading', [
       'loadingAddElem',
     ]),
     // transforme l'input du datepicker en objet date avec momentjs.
     saveTheDate(id, postedObject, theDate) {
       console.log("STRANGE ARG : " +  theDate);
       postedObject.birthday = new Date(theDate);
       this.updateModelObject(id, postedObject);
     },

     printTheDate(theDate) {
       // affiche la date au format attendu par le datepicker (YYYY-MM-DD)
       // https://stackoverflow.com/questions/48427705/using-new-date-with-v-date-picker-doesnt-work Aldo Canepa
       if(theDate) {
         console.log('MOMENT GETTER :::: ' + moment(theDate).format('YYYY-MM-DD'));
         // return moment(theDate).format('YYYY-MM-DD');
         // return moment(theDate).format('DD/MM/YYYY');
         return moment(theDate).locale('fr').format('ll');
       }
       else {
         // console.log("Pas de date")
         return null
       }
     },

     // IMPORTANT!!! l'astuce, afin de ne récupérer qu'un seul objet et non un array d'objet,
     // est d'appeller l'url ainsi :
     // '/api/' + this.cv_id + '/infoperso/' + this.cv_id + '/',
     // sans la redondance de cv_id, ont obtient un array, même s'il ne peut contenir qu'un objet.
     getModelObject: function() {
       this.isLoading = true;
       session.get(this.api_url)
              .then((response) => {
                // créer s'il n'y a aucun objet
                if (response.data.length == 0) {
                  console.log("!!!!!!!!!!!!! Objet PerINFO n'existe pas !!!!!!!!!");
                  this.addModelObject();
                }
                this.modelObject = response.data;
                this.isLoading = false;
                this.loadingAddElem();
                console.log('GET CALLED : ' + this.api_url);
                console.log(response)
              })
              .catch((err) => {
                this.isLoading = false;
                this.loadingAddElem();
                if (err.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log('======= getModelObject error in response =======')
                  console.log('objet err : ' + JSON.stringify(err.response));
                  console.log('errdata : ' + err.response.data);
                  console.log('errstatusText : ' + err.response.statusText);
                  console.log('errheader : ' + err.response.headers);
                  if (err.response.status == 404 && err.response.statusText == "Not Found") {
                    // Si le CV vient d'être créé, l'objet PersInfo n'existe pas encore
                    // On le créé avec addModelObject.
                    console.log("!!!!!! 404 Objet PersInfo n'existe pas encore !!!!!!!!!! --> " + err.response.statusText );
                    console.log("Création de l'objet PersInfo");
                    this.addModelObject();
                  }
                } else if (err.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log('======= getModelObject error in request =======')
                  console.log(err.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('======= getModelObject error in else =======')
                  console.log('Err', err.message);
                }
              })
     },

     updateModelObject: function(id, postedObject) {
       this.isLoading = true;
       this.currentModelObject = postedObject
       console.log("Changement sur l'objet : " + this.currentModelObject.curriculum);
       console.log(this.currentModelObject)
       console.log("POST vers l'url : " + this.api_url)
       // gestion de la protection csrf :
       // axios.defaults.xsrfCookieName = 'csrftoken'
       // axios.defaults.xsrfHeaderName = 'X-CSRFToken'
       var tempObjet = null

       if (this.currentModelObject.picture_file instanceof File ) {
         console.log('FORMDATA !!!')
         let formData = new FormData();
         formData.append('curriculum', this.currentModelObject.curriculum);
         formData.append('picture_file', this.currentModelObject.picture_file);

         session.put(this.api_url, formData)
                .then((response) => {
                  this.isLoading = false;
                  this.currentModelObject = response.data;
                  console.log("Get the whole thing again!")
                  this.getModelObject();
                })
                .catch((err) => {
                  this.isLoading = false;
                  if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('======= error in response =======')
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                  } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('======= error in request =======')
                    console.log(err.request);
                  } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('======= error in else =======')
                    console.log('Err', err.message);
                  }
                })
       }
       else {
         if (this.currentModelObject.picture_file != null) {

           console.log("JSON !!! --> protection du fichier");
           tempObjet =  {
             'title': this.currentModelObject.title,
             'firstname': this.currentModelObject.firstname,
             'lastname': this.currentModelObject.lastname,
             'birthday': this.currentModelObject.birthday,
             'nationality': this.currentModelObject.nationality,
             'address_street': this.currentModelObject.address_street,
             'address_postal_code': this.currentModelObject.address_postal_code,
             'address_city': this.currentModelObject.address_city,
             'address_country': this.currentModelObject.address_country,
             'telephone': this.currentModelObject.telephone,
             // 'picture_file': this.currentModelObject.picture_file,
             'curriculum': this.currentModelObject.curriculum,
           }
         }
         else {
           console.log("JSON !!! --> fichier à null");

           tempObjet =  {
             'title': this.currentModelObject.title,
             'firstname': this.currentModelObject.firstname,
             'lastname': this.currentModelObject.lastname,
             'birthday': this.currentModelObject.birthday,
             'nationality': this.currentModelObject.nationality,
             'address_street': this.currentModelObject.address_street,
             'address_postal_code': this.currentModelObject.address_postal_code,
             'address_city': this.currentModelObject.address_city,
             'address_country': this.currentModelObject.address_country,
             'telephone': this.currentModelObject.telephone,
             'picture_file': null,
             'curriculum': this.currentModelObject.curriculum,
           }
         }


         console.log(tempObjet.curriculum)

         session.put(this.api_url, tempObjet)
                .then((response) => {
                  this.isLoading = false;
                  this.currentModelObject = response.data;
                  this.getModelObject();
                })
                .catch((err) => {
                  this.isLoading = false;
                  if (err.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log('======= error in response =======')
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                  } else if (err.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log('======= error in request =======')
                    console.log(err.request);
                  } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('======= error in else =======')
                    console.log('Err', err.message);
                  }
                })
       }
     },



     pictureFileHandler: function(id, postedObject, myfile) {
       // gère l'ajout de la photo
       this.isLoading = true;
       console.log("Récup du fichier : ");
       console.log(myfile[0]);
       console.log(this.$refs.the_file.files);
       this.currentModelObject = postedObject;
       this.currentModelObject.picture_file = myfile[0];
       console.log(this.currentModelObject);
       this.updateModelObject(this.curriculum, this.currentModelObject);
       this.isLoading = false;
     },

     pictureDeleteHandler: function(id, postedObject) {
       // gère la suppression de la photo
       console.log('\n------ suppression du fichier --------')
       this.isLoading = true;
       this.currentModelObject = postedObject;
       this.currentModelObject.picture_file = null;
       this.updateModelObject(this.curriculum, this.currentModelObject);
       this.isLoading = false;
     },
   },
 }


</script>
